import React from "react";
import {CardBody, CardText, CardTitle} from "reactstrap";
import {useEventTypeLabels} from "./useEventTypeLabels";

const EventRuleCard = ({data}) => {
  const {name = "", description = "", event_types = [], enabled} = data;

  const getEventTypeLabels = useEventTypeLabels();
  const triggerLabels = getEventTypeLabels(event_types);

  return (
    <CardBody>
      <CardTitle>{name}</CardTitle>
      <CardText>{description}</CardText>
      <CardText>{`Triggers: ${triggerLabels.join(", ")}`}</CardText>
      <CardText>{`Status: ${enabled ? "Enabled" : "Disabled"}`}</CardText>
    </CardBody>
  );
};

export default EventRuleCard;
